import { getStorageValue } from 'src/hooks/useLocalStorage';

class ExcelExportService {
  static getEmergencyContactsXLSLink(personalInfoId: string) {
    return `${
      process.env.REACT_APP_API_URL
    }personal-informations/export-emergency-contacts/${personalInfoId}?token=${getStorageValue('accessToken', null)}`;
  }

  static getDependentsXLSLink(personalInfoId: string) {
    return `${
      process.env.REACT_APP_API_URL
    }personal-informations/export-dependents/${personalInfoId}?token=${getStorageValue('accessToken', null)}`;
  }

  static getPaymentsXLSLink(startDate: string, endDate: string) {
    return `${process.env.REACT_APP_API_URL}payments/export-paystubs-csv?token=${getStorageValue(
      'accessToken',
      null
    )}&startDate=${startDate}&endDate=${endDate}`;
  }

  static getSinglePaystubCSV(ptn: string) {
    return `${process.env.REACT_APP_API_URL}payments/export-single-paystub-csv?ptn=${ptn}&token=${getStorageValue(
      'accessToken',
      null
    )}`;
  }

  static getW2FormCSV(controlNumber: string) {
    return `${process.env.REACT_APP_API_URL}tax-forms/csv?controlNumber=${controlNumber}&token=${getStorageValue(
      'accessToken',
      null
    )}`;
  }
}

export default ExcelExportService;
